export const token = 'CollegePassToken_TP'
export const email = 'CollegePassEmail_TP'
export const isTestTaken = 'CollegePassIsTestTaken_TP'
export const testDetails = 'CollegePassTestDetails_TP'
